import REQUEST_TYPE from "./RequestTypes";
import AUTHENTICATION_CONSTANTS from "./AuthenticationConstants";
import HTTP_HEADER from "./HttpHeaders";
import API_CONSTANTS from "./ApiEndpointConstants";


const CONSTANTS = {
    AUTH_CONSTANTS: AUTHENTICATION_CONSTANTS,
    REQUEST_TYPE,
    HTTP_HEADER,
    API_CONSTANTS: API_CONSTANTS,
}

export default CONSTANTS;